export const EXPIRATION_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'Por defeito (30 dias)' },
  { value: '7', label: '1 semana' },
  { value: '14', label: '2 semanas' },
  { value: '21', label: '3 semanas' },
  { value: '30', label: '1 mês' },
  { value: '60', label: '2 meses' },
  { value: '90', label: '1 trimestre' },
  { value: '180', label: '1 semestre' },
  { value: '365', label: '1 ano' },
  { value: '730', label: '2 anos' },
  { value: '1095', label: '3 anos' },
]
